/**
 * Authentication helpers.
 *
 * Session tokens live only in HttpOnly cookies. Local profile data may be used
 * as a display cache, but it is never proof of authentication.
 */

import apiClient from './apiClient';

// Compatibility exports for older callers. Tokens are intentionally not
// readable by JavaScript.
export const getAccessToken = () => null;
export const getRefreshToken = () => null;
export const getAuthHeader = () => '';

export const clearAuthData = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
  sessionStorage.removeItem('user');
};

export const isAuthenticated = async () => {
  try {
    const response = await apiClient.get('/auth/me');
    return response.ok;
  } catch {
    return false;
  }
};

export const getUserRole = async () => {
  try {
    const response = await apiClient.get('/auth/me');
    if (response.ok) {
      const data = await response.json();
      return data.role || 'student';
    }
  } catch (error) {
    console.error('Error fetching user role:', error);
  }
  return null;
};
